import React, { useEffect, useRef, useState } from 'react';
import './linearprogressbar.css';

const LinearProgressBar = ({
  percentage = 100,
  duration = 1500,
  height = 24,
  fillColor = '#3e98c7',
  backgroundColor = '#eee',
  marginTop = 0,
  marginBottom = 0,
}) => {
  const [progress, setProgress] = useState(0);
  const [isVisible, setIsVisible] = useState(false);
  const ref = useRef(null);
  const barRef = useRef(null);

  useEffect(() => {
    const node = ref.current;
    const observer = new IntersectionObserver(
      ([entry]) => {
        setIsVisible(entry.isIntersecting);
      },
      { threshold: 0.3 }
    );

    if (node) observer.observe(node);
    return () => {
      if (node) observer.unobserve(node);
    };
  }, []);

  useEffect(() => {
    if (!isVisible) return;

    let start = null;

    const animate = (timestamp) => {
      if (!start) start = timestamp;
      const elapsed = timestamp - start;

      const current = Math.min((elapsed / duration) * percentage, percentage);
      setProgress(current);

      if (barRef.current) {
        barRef.current.style.width = `${current}%`;
      }

      if (current < percentage) {
        requestAnimationFrame(animate);
      }
    };

    requestAnimationFrame(animate);
  }, [isVisible, percentage, duration]);

  return (
    <div
      ref={ref}
      className="linear-progress-container"
      style={{ height, backgroundColor, marginTop, marginBottom }}
    >
      <div
        ref={barRef}
        className="linear-progress-bar"
        style={{
          backgroundColor: fillColor,
          height: '100%',
          width: '0%', // initial width
        }}
      />

      {/* Centered dual-layered text */}
      <div className="linear-progress-text-layer">
        <span className="text text-dark">{Math.round(progress)}%</span>
        <span
          className="text text-light"
          style={{
            clipPath: `inset(0 ${100 - progress}% 0 0)`,
          }}
        >
          {Math.round(progress)}%
        </span>
      </div>
    </div>
  );
};

export default LinearProgressBar;
